import React, { Component } from 'react';
import ReactGA from 'react-ga';
import Slider from 'react-slick';
import ImageViewer from './ImageViewer.js';
import VideoPlayer from './VideoPlayer.js';

import florenceTitleBox from './image/city/florence/florence_title_text.jpg';
import londonTitleBox from './image/city/london/london_title_text.jpg';
import milanTitleBox from './image/city/milan/milan_title_text.jpg';
import parisTitleBox from './image/city/paris/paris_title_text.jpg';
import playBtn from './image/play_video.png';

var PrevArrow = React.createClass({
	render: function() {
		return (
			<div className="arrow-prev" onClick={this.props.onClick}></div>
		);
	}
});

var NextArrow = React.createClass({
	render: function() {
		return (
			<div className="arrow-next" onClick={this.props.onClick}></div>
		);
	}
});

class City extends Component {
	constructor(props) {
		super(props);
		this.state = {
			imageUrl: false,
			videoMp4Url: false
		};
	}
	componentWillMount() {
		ReactGA.set({
			'dimension1': ':mini:fashionweekfw17',
			'dimension2': ':mini',
			'dimension3': ':mini:fashionweekfw17',
			'dimension4': ':mini:fashionweekfw17:'+this.props.location
		});
		ReactGA.pageview('/#city:'+this.props.location);
	}
	openUrl(url) {
		window.open(url, '_blank');
	}
	enableImageViewer(url) {
		this.setState({
			imageUrl: url
		})
	}
	disableImageViewer() {
		this.setState({
			imageUrl: false
		})
	}
	enableVidoePlayer(mp4Url) {
		this.setState({
			videoMp4Url: mp4Url
		})
	}
	disableVideoPlayer() {
		this.setState({
			videoMp4Url: false
		})
	}
	render() {
		var self = this;
		return (
			<div className="city">
				{
					(!!this.state.imageUrl) ?
						<ImageViewer url={this.state.imageUrl} onClose={this.disableImageViewer.bind(this)} />
					:
						(!!this.state.videoMp4Url) ?
							<VideoPlayer mp4url={this.state.videoMp4Url} onClose={this.disableVideoPlayer.bind(this)} />
						:
							null
				}
				<div className="sub-page-header">
					<div className="sub-page-title">
						<div>
							{
								(this.props.location === 'florence') ?
									<img alt="FLORENCE" src={florenceTitleBox} />
								:
									(this.props.location === 'london') ?
										<img alt="LONDON" src={londonTitleBox} />
									:
										(this.props.location === 'milan') ?
											<img alt="MILAN" src={milanTitleBox} />
										:
											(this.props.location === 'paris') ?
												<img alt="PARIS" src={parisTitleBox} />
											:
												null
							}
						</div>
					</div>
				</div>
				<div className="sub-page-content">
					<div className="graphic">
						<div className={this.props.location+" graphic1"}></div>
						<div className={this.props.location+" graphic2"}></div>
						<div className={this.props.location+" graphic3"}></div>
						<div className={this.props.location+" graphic4"}></div>
					</div>
					<div id="scrollable-area" className="scrollable-area">
						<div className="kv">
							<Slider className="slider" dots={true} infinite={true} prevArrow={<PrevArrow />} nextArrow={<NextArrow />}>
								{
									this.props.data.kv.map(function(item, index) {
										return (
											<div key={index} className="slide" onClick={self.openUrl.bind(self, item.destination_url+"?utm_source=mini&utm_medium=campaign&utm_campaign=fashionweekfw17")}>
												<img src={"http://campaign.esquirehk.com/"+self.props.data.kv[index].entry_image} alt="" />
												<div className="caption">{self.props.data.kv[index].text}</div>
											</div>
										)
									})
								}
							</Slider>
							<div className={"esky "+this.props.location}></div>
						</div>
						<div className="items">
							{
								this.props.data.data.map(function(item, index) {
									return (
										<div key={index} className="item-container">
											{
												(index === 2) ?
													<div className={"esky "+self.props.location}></div>
												:
													null
											}
											<div className="item" style={(!!item.video_src) ? {backgroundImage: "url("+playBtn+") ,url("+item.entry_image+")"}: {backgroundImage: "url("+item.entry_image+")"}}>
												<div className="hover for-desktop">
													{
														(!!item.video_src) ?
															<div className="border" onClick={self.enableVidoePlayer.bind(self, item.video_src)}>
																<div className="content">
																	{item.text.split("#")[0]}
																	<br />
																	<br />
																	<div>PLAY NOW &gt;</div>
																</div>
															</div>
														:
															<div className="border" onClick={self.enableImageViewer.bind(self, item.entry_image)}>
																<div className="content">
																	{item.text.split("#")[0]}
																	<br />
																	<br />
																	<div>MORE &gt;</div>
																</div>
															</div>
													}
												</div>
												<div className="hover for-mobile">
													{
														(!!item.video_src) ?
															<div className="border">
																<div className="content">
																	{item.text.split("#")[0]}
																	<br />
																	<br />
																	<div onClick={self.enableVidoePlayer.bind(self, item.video_src)}>PLAY NOW &gt;</div>
																</div>
															</div>
														:
															<div className="border">
																<div className="content">
																	{item.text.split("#")[0]}
																	<br />
																	<br />
																	<div onClick={self.enableImageViewer.bind(self, item.entry_image)}>MORE &gt;</div>
																</div>
															</div>
													}
												</div>
											</div>
										</div>
									)
								})
							}
						</div>
					</div>
				</div>
				<div className="fixed-on-bottom">
					<div className="fixed-esky-container">
						<div className={"fixed-esky "+this.props.location}></div>
					</div>
				</div>
			</div>
		);
	}
}

export default City;


// WEBPACK FOOTER //
// ./src/City.js